export default "__VITE_ASSET__bRtw4zdF__"